import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addPhoneData,
  deletePhoneById,
  fetchPhoneListData,
  updatePhoneClientData,
  updatePhoneData,
} from "../thunks/phoneListThunk";

import type { Phone } from "../../utils/types/type-helper";

interface PhoneListState {
  phoneList: Phone[]; // Changed from Phone[] to any[]
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: PhoneListState = {
  phoneList: [], // Changed type to any[]
  loading: false,
  error: null,
  isDataFetched: false,
};

export const phoneListSlice = createSlice({
  name: "phoneList",
  initialState,
  reducers: {
    resetDataFetched: (state) => {
      state.isDataFetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneListData.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
      })
      .addCase(fetchPhoneListData.fulfilled, (state, action) => {
        state.phoneList = action.payload || []; // No type enforcement
        state.loading = false;
      })
      .addCase(fetchPhoneListData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });
    builder
      .addCase(deletePhoneById.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePhoneById.fulfilled, (state, action) => {
        state.phoneList = state.phoneList.filter(
          (phone) => phone.phone_id !== action.payload
        );
        state.loading = false;
      })
      .addCase(deletePhoneById.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(addPhoneData.pending, (state) => {
        state.loading = true;
      })
      .addCase(addPhoneData.fulfilled, (state, action) => {
        state.phoneList = [action.payload?.data, ...state.phoneList];
        state.loading = false;
      })
      .addCase(addPhoneData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(updatePhoneData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePhoneData.fulfilled, (state, action) => {
        state.phoneList = state.phoneList.map((phone) => {
          if (phone.phone_id === action.payload?.phone_id) {
            return { ...phone, ...action.payload };
          }
          return phone;
        });
        state.loading = false;
      })
      .addCase(updatePhoneData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    builder
      .addCase(updatePhoneClientData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePhoneClientData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
    addWebSocketCases(builder, "phoneList", "phoneList");
  },
});

export const { resetDataFetched } = phoneListSlice.actions;
export default phoneListSlice.reducer;
